import {
  niceIso8601Time,
  formatStat,
  niceBlockedMessage,
} from '../shared'
import Cell from './Cell'

const PresetCell = ({preset, onShare, onDownload, onDelete}) => {
  const actions = []
  if (onShare && !preset.is_blocked) { actions.push({ title: 'Copy Link', onClick: () => { onShare(preset) } }) }
  if (onDownload) { actions.push({ title: 'Download', onClick: () => { onDownload(preset) } }) }
  if (onDelete) { actions.push({ title: 'Delete', onClick: () => { onDelete(preset) } }) }

  return <Cell>
    <Cell.Image src={preset.images['100']} alt='' />
    <Cell.Body>

      <Cell.Line>
        <Cell.LineTitle>{preset.name}</Cell.LineTitle>
        {preset.is_blocked && <Cell.LineImportant>{niceBlockedMessage(preset.is_blocked)}</Cell.LineImportant>}
        {!preset.is_blocked && preset.is_featured && <Cell.LineFeatured />}
      </Cell.Line>

      <Cell.Line>
        <div>{niceIso8601Time(preset.created_at)}</div>
      </Cell.Line>

      <Cell.Line>
        {<Cell.LikeCount>{formatStat(preset.like_count)}</Cell.LikeCount>}
      </Cell.Line>

    </Cell.Body>
    {actions.length > 0 && <Cell.OverflowButton actions={actions} />}
  </Cell>
}

export default PresetCell
